/* eslint-disable import/no-unresolved */
import styled, { css } from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Icon, Link } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, FontFamily, Components,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import 'swiper/css/parallax';
import 'swiper/css/controller';

const CPNT = Components.ORDERED_SHOWCASE;

export const StyledSwiper = styled(Swiper)`
  .swiper-wrapper {
    align-items: flex-end;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  height: 100%;
`;

export const StyledOrderedShowcase = styled.div`
  //display: flex;
  //flex-direction: column;
  width: 100%;
`;

export const ShowcaseItems = styled.ol`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 25px;
`;

export const ItemWrapper = styled.li`
  width: 100%;
  height: 100%;
  list-style: none;
`;

export const IndicatorBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;

  ${Breakpoints.desktopOnly(css`
    margin: ${({ $is5050 }) => (($is5050) ? '20px 0 20px' : '40px 0 30px')};
  `)}

  ${Breakpoints.mobile(css`
    margin: 20px 0 20px;
  `)}
`;

export const BarElement = styled.div`
  background-color: lightgrey;
  height: 10px;
  width: 100%;
  border-radius: 5px;
`;

export const IndicatorIconWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: ${({ $indicatorOffsetLeft }) => `${$indicatorOffsetLeft}%`};
  transform: translateX(-50%);
  width: ${({ $indicatorWidth }) => `${$indicatorWidth}%`};
  ${({ $grabbable }) => ($grabbable) && 'cursor: grab'};
  pointer-events: auto;
  gap: 5px;
  transition: left 0.3s ease, transform 0.3s ease;

  ${Breakpoints.desktopOnly(css`
    top: ${({ $is5050 }) => (($is5050) ? 9 : 5)}px;
  `)}

  ${Breakpoints.mobile(css`
    top: 9px;
  `)}
`;

export const IndicatorIcon = styled(Icon)`
  display: flex;
  flex-direction: column;
  filter: drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.4));
  align-items: center;

  ${Breakpoints.desktopOnly(css`
    height: ${({ $is5050 }) => (($is5050) ? 25 : 35)}px;
  `)}

  ${Breakpoints.mobile(css`
    height: 25px;
  `)}
`;

export const IndicatorText = styled.div`
  font-weight: bold;
  text-align: center;

  ${Breakpoints.desktopOnly(css`
    ${({ $is5050 }) => (($is5050)
    ? getFontStyles(FontFamily.BASE_FONT, undefined, 0.85)
    : getFontStyles(FontFamily.BASE_FONT, undefined, undefined))};
  `)}

  ${Breakpoints.mobile(css`
    ${() => getFontStyles(FontFamily.BASE_FONT, undefined, 0.85)};
  `)}
`;

export const IndicatorButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
  ${() => getFontStyles(FontFamily.SECONDARY_FONT)};
  padding: 10px;
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
  color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
  transition: color 0.25s ease-out, background-color 0.25s ease-out;

  &:hover, &:focus {
    transition: color 0.25s ease-out, background-color 0.25s ease-out;
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
  }

  &:focus {
    outline: 2px solid ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    outline-offset: 0.1em;
  }
`;
